import React, { useState } from "react";
import { TextField, Grid, Box, Divider, Typography,Switch } from "@mui/material";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { callApi } from "../../../utils/apiClient";
import { Warehouse_API_ENDPOINTS } from "../../../config/api/apiCallWarehouse";
import WarehouseEnvironmentActionMenu from "./WarehouseEnvironmentActionMenu";
import { ToastContainer } from "react-toastify";

const AddUpdateWarehouseEnvironment = ({
  envFormData,
  setEnvFormData,
  setIsFormOpen,
  LoadEnvironmentList,
}) => {
  const isEdit = !!(envFormData?.environment_type_id && envFormData.environment_type_id !== 0);
  const envId = envFormData?.environment_type_id || 0;

  // ✅ Toast setup (initialize once)
  //toast.dismiss();
React.useEffect(() => {
  if (!envFormData || envFormData.environment_id === 0) {
    setEnvFormData((prev) => ({ ...prev, status: true }));
  }
}, []);
  const handleSave = async () => {
    if (!envFormData.code?.trim()) {
      toast.warn("Please enter Warehouse Environment Type Code.");
      return;
    }
    if (!envFormData.description?.trim()) {
      toast.warn("Please enter Warehouse Environment Type Description.");
      return;
    }

    const payload = {
      p_id: envId,
      p_code: envFormData.code,
      p_description: envFormData.description,
      p_company_id: localStorage.getItem("companyid"),
      p_plant_id: 1,
      p_created_by: 100,
      p_updated_by: 100,
      p_status:envFormData.status,
    };

    const endpoint = isEdit
      ? Warehouse_API_ENDPOINTS.environmentType.update
      : Warehouse_API_ENDPOINTS.environmentType.create;

    try {
      const data = await callApi(endpoint, "POST", { "Content-Type": "application/json" }, payload);
      const message =
         data[0]?.message ||       // fallback if API returns plain object
          "Object Type updated successfully!";
        // ✅ Success message
            toast.success(
             message,
              { position: toast.POSITION.BOTTOM_CENTER, autoClose: 2000 }
            );
      //toast.success('Environment Type saved successfully!', { position: toast.POSITION.BOTTOM_CENTER },{autoclose:60000});
        //'Bank account type deleted Successfully.', { position: toast.POSITION.BOTTOM_CENTER }
      LoadEnvironmentList();

      // If new record created, set to edit mode
      if (!isEdit && data?.[0]?.environment_type_id) {
        setEnvFormData({
          ...envFormData,
          environment_type_id: data[0].environment_type_id,
        });
      }
    } catch (error) {
      console.error("Error saving environment:", error);
     const errorMsg =
           error?.data?.message ||
           error?.message ||
           "Failed to save Warehouse Type";
         toast.error(errorMsg, {
           position: toast.POSITION.BOTTOM_CENTER,
           autoClose: 2000,
         });
         }
  };

  const handleDelete = async () => {
    if (!isEdit) {
      toast.info("Please select a record to delete.");
      return;
    }

    const confirmed = window.confirm("Are you sure you want to delete this Environment Type?");
    if (!confirmed) return;

    const payload = {
      p_id: envId,
      p_code: envFormData.code,
      p_description: envFormData.description,
      p_company_id: localStorage.getItem("companyid"),
      p_plant_id: 1,
      p_created_by: 100,
    };

    try {
      await callApi(
        Warehouse_API_ENDPOINTS.environmentType.delete,
        "POST",
        { "Content-Type": "application/json" },
        payload
      );
      //toast.success("Environment Type deleted successfully!",{ position: toast.POSITION.BOTTOM_CENTER },{autoclose:60000});
      toast.success("Environment Type deleted successfully!", 
  { position: toast.POSITION.BOTTOM_CENTER }, 
  { autoClose: 2000 }
);
      LoadEnvironmentList();

      // Reset to new mode
      setEnvFormData({
        environment_type_id: 0,
        code: "",
        description: "",
      });
    } catch (error) {
      console.error("Error deleting environment:", error);
      toast.error("Failed to delete environment type!");
    }
  };

  const handleClear = () => {
    setEnvFormData({
      environment_type_id: 0,
      code: "",
      description: "",
    });
    toast.info("Form cleared — ready for new entry.");
  };

  const handleExit = () => setIsFormOpen(false);

  return (
    <Box fullWidth>
      {/* 🔹 Action Menu */}
      <WarehouseEnvironmentActionMenu
        isEdit={isEdit}
        onSave={handleSave}
        onDelete={handleDelete}
        onClear={handleClear}
        onExit={handleExit}
        saveDisabled={!envFormData.code || !envFormData.description}
      />

      <Divider />

      {/* 🔹 Form Section */}
      <Box p={3}>
        <Grid container spacing={3}>
          {/* Code Field */}
          <Grid item xs={12}>
            <Box
              display="grid"
              gridTemplateColumns={{
                xs: "repeat(2, 1fr)",
                sm: "repeat(12, 1fr)",
              }}
              gap={{ xs: "20px", sm: "10px" }}
              alignItems="center"
            >
              <Box gridColumn="span 2">
                <Typography
                  variant="h6"
                  sx={{ color: "#fff", fontSize: 14, fontWeight: 600 }}
                >
                  Code
                </Typography>
              </Box>
              <Box gridColumn="span 5">
                <TextField
                  fullWidth
                  size="small"
                  color="secondary"
                  placeholder="Enter Environment Code"
                  value={envFormData.code || ""}
                  onChange={(e) =>
                    setEnvFormData({
                      ...envFormData,
                      code: e.target.value.toUpperCase(),
                    })
                  }
                  inputProps={{ style: { color: "#fff" } }}
                  disabled={isEdit}
                />
              </Box>
            </Box>
          </Grid>

          {/* Description Field */}
          <Grid item xs={12}>
            <Box
              display="grid"
              gridTemplateColumns={{
                xs: "repeat(2, 1fr)",
                sm: "repeat(12, 1fr)",
              }}
              gap={{ xs: "20px", sm: "10px" }}
              alignItems="center"
            >
              <Box gridColumn="span 2">
                <Typography
                  variant="h6"
                  sx={{ color: "#fff", fontSize: 14, fontWeight: 600 }}
                >
                  Description
                </Typography>
              </Box>
              <Box gridColumn="span 5">
                <TextField
                  fullWidth
                  size="small"
                  color="secondary"
                  placeholder="Enter Description"
                  value={envFormData.description || ""}
                  onChange={(e) =>
                    setEnvFormData({
                      ...envFormData,
                      description: e.target.value.toUpperCase(),
                    })
                  }
                  inputProps={{ style: { color: "#fff" } }}
                />
              </Box>
            </Box>
          </Grid>
           {/* STATUS ROW */}
                    <Grid item xs={12}>
                      <Box
                        display="grid"
                        gridTemplateColumns={{
                          xs: 'repeat(2, 1fr)',
                          sm: 'repeat(12, 1fr)',
                        }}
                        gap={{ xs: '20px', sm: '10px' }}
                        alignItems="center"
                      >
                       <Box gridColumn="span 2">
  <Typography variant="h6">Status</Typography>
</Box>
<Box gridColumn="span 5" display="flex" alignItems="center" gap={1}>
  <Switch
    checked={envFormData.status === undefined ? true : envFormData.status}
    color="secondary"
    onChange={(e) =>
      setEnvFormData({
        ...envFormData,
        status: e.target.checked,
      })
    }
  />
  <Typography>
    {envFormData.status === undefined
      ? "Active"
      : envFormData.status
      ? "Active"
      : "Inactive"}
  </Typography>
</Box>

                      </Box>
                    </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default AddUpdateWarehouseEnvironment;
